module.exports = __webpack_public_path__ + "static/img/risk_sp3.a1b2663.png";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/risk_sp3.png
// module id = 931
// module chunks = 1